import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import { v4 as uuid } from 'uuid';
import agent from '../../app/api/agent';
import { store } from '../../app/stores/store';

export interface pivotData {
  id: string;
  customerName: string;
  tableName: string;
  start: string;
  end: string;
  row: string[];
  column: string[];
  tableValue: string[];
}
export interface PinnedInterface {
  id: string;
  userId: string;
  pinnedAssets: string[];
}

export default class ReportStore {
  constructor() {
    makeAutoObservable(this);
  }

  saveAsPivotRegistry = new Map<string, pivotData>();
  pinnedIDForUser: PinnedInterface | undefined = undefined;

  //pivot Report Keys
  pivotReportKeys: string[] = [];
  //set pivot report Keys
  chosenPivotReportKeys: string[] = [];
  mainPivotData = [];
  mainPivotData2 = [];
  showPivotReport: boolean = false;
  showPivotReport2: boolean = false;
  loadCheckBox: boolean = false;
  loadPivotTable: boolean = false;
  pivotReportModal: boolean = false;
  pivotRow: string[] = [];
  pivotColumn: string[] = [];
  progressCount = 0;

  saveAsPivot: pivotData = {
    id: '',
    customerName: '',
    tableName: '',
    start: '',
    end: '',
    row: [''],
    column: [''],
    tableValue: [''],
  };

  totalPivotCount = 0;
  increaseCount = 0;

  getExistingPinnedIDs = async (userId: string) => {
    const response = await agent.Reports.getPinnedIds(userId);
    if (response.data[0]) {
      this.pinnedIDForUser = response.data[0];
    }
  };
  pinnedIds = async (userId: string, reportId: string) => {
    const response = await agent.Reports.getPinnedIds(userId);

    if (response.data === 'Assets is not Pinned') {
      let newArr = {
        id: uuid(),
        userId: userId,
        pinnedAssets: [reportId],
      };
      await agent.Reports.postPinnedIds(newArr);
      toast.success('Report Added for quick access successfully');
    } else {
      let newArr: PinnedInterface = response.data[0];
      if (newArr.pinnedAssets.includes(reportId)) {
        newArr.pinnedAssets = newArr.pinnedAssets.filter(
          (ids: string) => ids !== reportId,
        );
        await agent.Reports.editPinnedIds(newArr);
        toast.success('Report removed from quick access successfully');
        // this.chosenPivotReportKeys.filter(item => item !== data.label)
      } else {
        if (newArr?.pinnedAssets?.length < 3) {
          newArr.pinnedAssets = newArr.pinnedAssets.concat(reportId);
          await agent.Reports.editPinnedIds(newArr);
          toast.success('Report Added for quick access successfully');
        } else {
          toast.error(
            'Sorry, you can only add 3 reports of your choice to the dashboard ',
          );
        }
      }
    }
    this.getExistingPinnedIDs(userId);
  };

  setInitialData = () => {
    this.pivotReportKeys = [];
    this.showPivotReport = false;
    this.loadCheckBox = false;
    this.loadPivotTable = false;
    this.mainPivotData = [];
  };

  get getPivotReportKeys() {
    return this.pivotReportKeys.filter(function (item, pos, self) {
      return self.indexOf(item) === pos;
    });
  }
  //set chosen pivot data
  setChosenMetaData = (data: any) => {
    if (data.checked === false) {
      this.chosenPivotReportKeys = this.chosenPivotReportKeys.filter(
        (item) => item !== data.label,
      );
    } else {
      this.chosenPivotReportKeys.push(data.label);
    }
  };

  setOpenPivotReportModal = (data: boolean) => {
    this.pivotReportModal = data;
  };

  loadPivotReportkeys = async (startdate: any, endDate: any) => {
    this.showPivotReport = false;
    this.loadCheckBox = true;
    this.increaseCount = 0;
    try {
      this.pivotReportKeys = [];
      let Countresponse = await agent.Reports.loadPivotCount(
        startdate,
        endDate,
      );

      if (Countresponse > 0 && Countresponse !== 'Item Not Found') {
        let response = await agent.Reports.metadataReportKeys(
          store.userStore.user?.customerName!,
        );
        const name = response.map((item: any) => {
          return item.replaceAll(/vault/gi, 'Room');
        });
        store.userStore.user?.customerName === 'LVP CMS - AM'
          ? (response = name)
          : console.log('');

        response.forEach((element: string) => {
          if (!this.pivotReportKeys.includes(element)) {
            this.pivotReportKeys.push(element);
          }
        });
      } else {
        toast.error('No item found at the selected date');
      }
      this.increaseCount = 100;
      this.loadCheckBox = false;
    } catch (error) {
      this.loadCheckBox = false;
    }
  };
  saveChosenPivotData = async (
    startdate: any,
    enddate: any,
    pagenum: number,
    pagesize: number,
  ) => {
    this.loadPivotTable = true;
    this.increaseCount = 0;
    try {
      this.mainPivotData = [];
      let response = await agent.Reports.loadPivotCount(startdate, enddate);
      let AsyncCallLength = Math.ceil(response / 250);

      this.totalPivotCount = response;
      for (let i = 1; i <= AsyncCallLength; i++) {
        const name = this.chosenPivotReportKeys?.map((item: any) => {
          return item.replaceAll(/room/gi, 'vault');
        });
        const response = await agent.Reports.loadPivotData(
          startdate,
          enddate,
          i,
          250,
          name,
        );
        if (response.data !== 'Item Not found') {
          try {
            const parsedData = JSON.parse(response.data);
            runInAction(() => {
              Array.prototype.push.apply(this.mainPivotData, parsedData);
              this.progressCount = (100 / AsyncCallLength) * i;
              if (this.progressCount === 100) {
                this.progressCount = 0;
              }
            });
          } catch (err) {
            console.log(err);
          }
        }
        this.increaseCount += 100;
      }

      this.showPivotReport = true;
      this.loadPivotTable = false;
    } catch (err) {
      toast.error('failed to load pivot data');
      this.showPivotReport = false;
      this.loadPivotTable = false;
    }
  };

  setPivotRowandColumn = (rowData: string[], colData: string[]) => {
    this.pivotRow = rowData;
    this.pivotColumn = colData;
  };
  //Final Save as Pivot Method
  saveAsPivotData = async (
    pivotName: string,
    startDate: string,
    endDate: string,
    id: string,
  ) => {
    try {
      let start = this.dateFormat(startDate);
      let end = this.dateFormat(endDate);
      let newSavePivot = {
        id: id,
        customerName: store.userStore.user?.customerName!,
        tableName: pivotName,
        start: start,
        end: end,
        row: this.pivotRow,
        column: this.pivotColumn,
        tableValue: this.chosenPivotReportKeys,
      };
      await agent.Reports.saveAsPivot(newSavePivot);
      runInAction(() => {
        this.setSaveAsPivotAll(newSavePivot);
      });
      toast.success('Posted');
    } catch (err) {
      console.log(err);
    }
  };
  get saveAsPivotDataAll() {
    return Array.from(this.saveAsPivotRegistry.values());
  }
  private setSaveAsPivotAll = (data: pivotData) => {
    this.saveAsPivotRegistry.set(data.id, data);
  };
  getSavedAsPivot = async (customerName: string) => {
    try {
      const response = await agent.Reports.getSaveasPivotReports(
        customerName || '',
      );
      runInAction(() => {
        response.forEach((data) => {
          this.setSaveAsPivotAll(data);
        });
      });
    } catch (err) {
      console.log(err);
    }
  };

  //Pivot Single
  //for Save as Pivot
  singleSaveAsPivot: pivotData | undefined = undefined;
  pivotRow2: string[] = [];
  pivotColumn2: string[] = [];
  pivotReportKeysSingle: string[] = [];
  chosenPivotReportKeysSingle: string[] = [];

  getSingleSaveAsPivot = async (id: string) => {
    try {
      const singleData = await agent.Reports.getSingleSaveAsPivotReports(id);
      runInAction(() => {
        if (singleData) {
          this.showPivotReport2 = true;
          this.singleSaveAsPivot = singleData;

          this.pivotRow2 = singleData.row;
          this.pivotColumn2 = singleData.column;
          this.chosenPivotReportKeysSingle = singleData.tableValue;
          this.pivotReportKeysSingle = singleData.tableValue;
          //end date always today's date

          singleData.end = this.dateFormat(new Date().toLocaleDateString('en'));
          singleData.start = this.dateFormat(singleData.start);
          // let replaceDate:string[]=endDate.split("-");
          // let replaceDate2=replaceDate[2]+"-"+replaceDate[1]+"-"+replaceDate[0]
          // this.singleSaveAsPivot.end=endDate;
          // this.singleSaveAsPivot.start = startDate;
          this.saveChosenPivotData2(singleData.start, singleData.end);
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  get getPivotReportKeys2() {
    return this.pivotReportKeysSingle.filter(function (item, pos, self) {
      return self.indexOf(item) === pos;
    });
  }

  loadPivotReportkeys2 = async (startdate: any, endDate: any) => {
    this.showPivotReport2 = false;
    this.loadCheckBox = true;
    this.increaseCount = 0;
    try {
      this.pivotReportKeysSingle = [];
      let response = await agent.Reports.loadPivotCount(startdate, endDate);
      let AsyncCallLength = Math.ceil(response / 250);
      this.totalPivotCount = response;
      //    this.loadingPivotReport=true;
      for (let i = 1; i <= AsyncCallLength; i++) {
        const activities = await agent.Reports.PivotReportKeys(
          startdate,
          endDate,
          i,
          250,
        );
        if (activities.data !== 'Item Not found') {
          try {
            const parsedData = JSON.parse(activities.data);
            runInAction(() => {
              Array.prototype.push.apply(
                this.pivotReportKeysSingle,
                parsedData,
              );
            });
          } catch (err) {
            console.log(err);
          }
        }
        //     this.metadataRegistry=  new Map <string, any>();
        this.increaseCount += 25;
      }

      this.loadCheckBox = false;
    } catch (error) {
      this.loadCheckBox = false;
    }
  };
  setChosenMetaData2 = (data: any) => {
    if (data.checked === false) {
      this.chosenPivotReportKeysSingle =
        this.chosenPivotReportKeysSingle.filter((item) => item !== data.label);
    } else {
      this.chosenPivotReportKeysSingle.push(data.label);
    }
  };
  saveChosenPivotData2 = async (startdate: any, enddate: any) => {
    this.loadPivotTable = true;
    this.increaseCount = 0;

    try {
      this.mainPivotData2 = [];
      let response = await agent.Reports.loadPivotCount(startdate, enddate);
      let AsyncCallLength = Math.ceil(response / 250);
      this.totalPivotCount = response;
      for (let i = 1; i <= AsyncCallLength; i++) {
        const chosenPivotReportKeysSingle1 =
          this.chosenPivotReportKeysSingle?.map((item: any) => {
            return item.replaceAll(/Room/gi, 'vault');
          });
        store.userStore.user?.customerName === 'LVP CMS - AM'
          ? (this.chosenPivotReportKeysSingle = chosenPivotReportKeysSingle1)
          : console.log('');

        const response = await agent.Reports.loadPivotData(
          startdate,
          enddate,
          i,
          250,
          this.chosenPivotReportKeysSingle,
        );

        if (response.data !== 'Item Not found') {
          try {
            const parsedData = JSON.parse(response.data);
            runInAction(() => {
              Array.prototype.push.apply(this.mainPivotData2, parsedData);
            });
          } catch (e) {
            console.log(e); // error in the above string (in this case, yes)!
          }
        }
        this.increaseCount += 100;
      }

      this.showPivotReport2 = true;
      this.loadPivotTable = false;
    } catch (err) {
      toast.error('failed to load pivot data');
      this.showPivotReport2 = false;
      this.loadPivotTable = false;
    }
  };
  setPivotRowandColumn2 = (rowData: string[], colData: string[]) => {
    this.pivotRow2 = rowData;
    this.pivotColumn2 = colData;
  };
  updateUserSaveAsPivotData = async (data: pivotData) => {
    try {
      data.row = this.pivotRow2;
      data.column = this.pivotColumn2;
      await agent.Reports.updateSingleUserReport(data);
      runInAction(() => {
        toast.success('Updated Successfully');
      });
    } catch (err) {
      toast.error('Failed to Update');
    }
  };
  deleteUserData = async (id: string) => {
    try {
      await agent.Reports.deleteSingleUserReport(id);
      this.saveAsPivotRegistry.delete(id);
      runInAction(() => {
        toast.success('Deleted Successfully');
      });
    } catch (err) {
      toast.error('Failed to Delete');
    }
  };

  dateFormat(inputDate: string) {
    let format = 'MM-dd-yyyy';
    //parse the input date
    const date = new Date(inputDate);

    //extract the parts of the date
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    //replace the month
    format = format.replace('MM', month.toString().padStart(2, '0'));

    //replace the year
    if (format.indexOf('yyyy') > -1) {
      format = format.replace('yyyy', year.toString());
    } else if (format.indexOf('yy') > -1) {
      format = format.replace('yy', year.toString().substr(2, 2));
    }

    //replace the day
    format = format.replace('dd', day.toString().padStart(2, '0'));

    return format;
  }
}
